export const fullNameUser = (user) => (user
  ? `${user.first_name} ${user.last_name} ${user.second_last_name || ''}` : '');

export default fullNameUser;
